export default {"PACKAGE_VERSION": "2.1.102672.0 (6a9756df)","UI_THEME": "polaris"}